import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Regex = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.6842 6.24047L12.3598 8.92814L13.6589 7.94611L11.7818 5.48026L14.6162 4.66467L14.1376 3.08383L11.2607 4.22222L11.4025 1H9.80709L9.96456 4.18095L7.11764 3.03593L6.61621 4.64072L9.56286 5.49368L7.64185 7.99401L8.96379 9L10.6842 6.24047Z"
      fill="currentColor"
    />
    <path d="M5 11H1V15H5V11Z" fill="currentColor" />
  </Icon>
));

export default Regex;
